import React, { Component } from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'

import { withRouter } from 'react-router-dom'
import { withTranslation } from 'react-i18next'

import { newsCommunicator } from '../../../../../../../communicators/newsCommunicator'

import { SectionTitle } from '../../../../../../components/SectionTitle/SectionTitle'
import { ErrorBoundary } from '../../../../../../components/ErrorBoundary/ErrorBoundary'
import { DetailsLink } from '../../../../../../components/DetailsLink/DetailsLink'
import { RelatedNewsList } from '../RelatedNews/RelatedNewsList/RelatedNewsList'
import { PKS_NEWS_CATEGORIES, PKS_NEWS_CATEGORY } from '../../../../../../../config/pks-constants'

class RegionalChamberNews extends Component {
    constructor(props) {
        super(props)
        this.state = {
            regionalChamberNews: []
        }
    }

    componentDidMount() {
        this.loadRegionalChamberNews()
    }

    async loadRegionalChamberNews() {
        try {
            const response = await newsCommunicator.fetchRCNewsOnMainSite()

            this.setState({ regionalChamberNews: response.rcNews })
        } catch (error) {
            console.error(error.message)
        }
    }

    onMoreNews = () => {
        const slug = PKS_NEWS_CATEGORIES.REGIONAL_CHAMBERS
            ? PKS_NEWS_CATEGORIES.REGIONAL_CHAMBERS.slug
            : ''
        this.props.history.push(
            `/sve-vesti/kategorija/${PKS_NEWS_CATEGORY.REGIONAL_CHAMBERS}/${slug}`
        )
    }

    render() {
        const { t } = this.props
        const { regionalChamberNews } = this.state

        if (_.isEmpty(regionalChamberNews)) {
            return null
        }

        return (
            <div className="related-news">
                <div className="related-news__title section-title-centered">
                    <SectionTitle title={t('singleArticle.regionalNews.title')} underlineClass />
                </div>
                <ErrorBoundary>
                    <RelatedNewsList relatedNewsList={regionalChamberNews} />
                </ErrorBoundary>
                <DetailsLink
                    text={t('singleArticle.relatedNews.details')}
                    onDetailsClick={this.onMoreNews}
                />
            </div>
        )
    }
}

RegionalChamberNews.propTypes = {
    t: PropTypes.func
}

export { RegionalChamberNews }
export default withTranslation()(withRouter(RegionalChamberNews))
